// @flow

import * as React from 'react';

import Toolbar from './Components/Toolbar';
import Table from './Components/Table';

type Props = {
  project: {},
  feedback: [],
  onClickRequestFeedback: Function,
  onClickDownloadFeedback: Function,
}

export default class extends React.PureComponent<Props> {

  render () {
    
    const {
      project,
      feedback,
      onClickRequestFeedback,
      onClickDownloadFeedback,
    } = this.props;

    return (
      <React.Fragment>

        <Toolbar
          project={project}
          onClickRequestFeedback={onClickRequestFeedback}
        />

        <Table
          project={project}
          feedback={feedback}
          onClickDownloadFeedback={onClickDownloadFeedback}
        />

      </React.Fragment>
    )
  }
}
